import { ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ExecutionQTestDeviationData, ExecutionQTestDeviations } from 'src/app/model/execution';
import { UserService } from '../../../../services/user.service';
import { User } from '../../../../model/user';
import { TestTypeDeviations, ExecutionStatus } from '../../../../model/execution';
import { SnackBarService } from '../../../../services/snackBar.service';
import { StringUtils } from '../../../../utils/stringUtils';
import { forkJoin, Observable, Subject, takeUntil } from 'rxjs';
import { AttachmentQualificatesService } from 'src/app/services/attachmentQualificates.service';
import { SpinnerService } from 'src/app/services/spinner.service';
import { ArrayUtils } from 'src/app/utils/arrayUtils';
import { TranslateService } from '@ngx-translate/core';
import { saveAs } from 'file-saver';
import { ExecutionUtils } from 'src/app/utils/executionUtils';
import { ExecutionQService } from 'src/app/services/executionQ.service';
import { ExecutionReportFilter } from 'src/app/model/attachment';
import { ExecutionQDeviationService } from '../../../../services/executionQTestDeviation.service';
import { v4 as uuid } from 'uuid';
import { MatSelectChange } from '@angular/material/select';
import { ProtocolUtils } from '../../../../utils/protocolUtils';

export interface DialogDataDeviation {
  protocolNumber: number;
  deviation: ExecutionQTestDeviations;
  idStatus: number;
  idExecution: number;
  idExecutionTest: number;
  isEditList: boolean;
  deviationsComplete: ExecutionQTestDeviations[];
  executionNumber: string;
}
@Component({
    selector: 'app-execution-edit-q-deviation',
    templateUrl: './execution-edit-q-deviation.component.html',
    styleUrls: ['./execution-edit-q-deviation.component.scss'],
    standalone: false,
})
export class ExecutionEditQDeviationComponent implements OnInit {

  commentsDeviation: ExecutionQTestDeviationData = new ExecutionQTestDeviationData();
  evaluation: ExecutionQTestDeviationData = new ExecutionQTestDeviationData();
  proposedCorrective: ExecutionQTestDeviationData = new ExecutionQTestDeviationData();
  actionsTaken: ExecutionQTestDeviationData = new ExecutionQTestDeviationData();
  deviationResolution: ExecutionQTestDeviationData = new ExecutionQTestDeviationData();
  closedDeviation: ExecutionQTestDeviationData = new ExecutionQTestDeviationData();
  reportConfig: ExecutionReportFilter = new ExecutionReportFilter();

  seeMore: boolean = false;
  currentUser: User;

  private destroy$ = new Subject<void>();


  constructor(private dialogRef: MatDialogRef<ExecutionEditQDeviationComponent>,
    private userService: UserService,
    private snackBarService: SnackBarService,
    private attachmentService: AttachmentQualificatesService,
    private spinnerService: SpinnerService,
    private translate: TranslateService,
    private deviationService: ExecutionQDeviationService,
    private cdRef: ChangeDetectorRef,
    private executionService: ExecutionQService,
    @Inject(MAT_DIALOG_DATA) public data: DialogDataDeviation) { }

  ngOnInit(): void {
    this.currentUser = this.userService.currentProfile;
    this.reportConfig.lang = this.translate.currentLang;

    if (!this.data.deviation.id) {
      const codeList = this.data.deviationsComplete?.map(ds => ds.codeDeviation);
      this.data.deviation.codeDeviation = 'D-'+this.data.executionNumber+"-"+ProtocolUtils.getMaxNumberDeviation(codeList);
      this.data.deviation.modDate = new Date();
      this.data.deviation.modUser = this.currentUser.username;
      this.data.deviation.uuid = uuid();
    }

    this.data.deviation?.executionQTestDeviationData?.forEach(eqtdd => {
      if (eqtdd.idType === TestTypeDeviations.COMMENTS) {
        this.commentsDeviation = eqtdd;
      }

      if (eqtdd.idType === TestTypeDeviations.VALUATION) {
        this.evaluation = eqtdd;
      }

      if (eqtdd.idType === TestTypeDeviations.PROPOSED_CORRECTIVE) {
        this.proposedCorrective = eqtdd;
      }

      if (eqtdd.idType === TestTypeDeviations.ACTIONS_TAKEN) {
        this.actionsTaken = eqtdd;
      }

      if (eqtdd.idType === TestTypeDeviations.DEVIATION_RESOLUTION) {
        this.deviationResolution = eqtdd;
      }

      if (eqtdd.idType === TestTypeDeviations.DEVIATION_CLOSED) {
        this.closedDeviation = eqtdd;
      }
    })
  }

  onOkClick() {

    const errores = this.getErroresDeviation();

    if (errores.length !== 0) {
      this.snackBarService.sendError(errores.join('\n'));
    } else {
      if (!this.data.deviation) {
        this.data.deviation = new ExecutionQTestDeviations();
      }

      if (!this.data.deviation.executionQTestDeviationData) {
        this.data.deviation.executionQTestDeviationData = []
      }

      if (this.commentsDeviation) {
        let res = this.data.deviation.executionQTestDeviationData.findIndex(eqtdd => eqtdd.idType === TestTypeDeviations.COMMENTS);

        if (res === -1) {
          if (this.commentsDeviation.comments && this.commentsDeviation.comments.trim() !== "") {
            this.commentsDeviation.idType = TestTypeDeviations.COMMENTS;
            this.data.deviation.executionQTestDeviationData.push(this.commentsDeviation);
          }
        } else {
          this.data.deviation.executionQTestDeviationData[res].comments = this.commentsDeviation.comments;
        }
      }

      if (this.deviationResolution) {
        let res = this.data.deviation.executionQTestDeviationData.findIndex(eqtdd => eqtdd.idType === TestTypeDeviations.DEVIATION_RESOLUTION);

        if (res === -1) {
          if ((this.deviationResolution.comments && this.deviationResolution.comments.trim() !== "") || this.deviationResolution.resolved != undefined) {
            this.deviationResolution.idType = TestTypeDeviations.DEVIATION_RESOLUTION;
            this.data.deviation.executionQTestDeviationData.push(this.deviationResolution);
          }
        } else {
          this.data.deviation.executionQTestDeviationData[res].comments = this.deviationResolution.comments;
          this.data.deviation.executionQTestDeviationData[res].resolved = this.deviationResolution.resolved;
        }
      }

      if (this.actionsTaken) {
        let res = this.data.deviation.executionQTestDeviationData.findIndex(eqtdd => eqtdd.idType === TestTypeDeviations.ACTIONS_TAKEN);

        if (res === -1) {
          if (this.actionsTaken.comments && this.actionsTaken.comments.trim() !== "") {
            this.actionsTaken.idType = TestTypeDeviations.ACTIONS_TAKEN;
            this.data.deviation.executionQTestDeviationData.push(this.actionsTaken);
          }
        } else {
          this.data.deviation.executionQTestDeviationData[res].comments = this.actionsTaken.comments;
        }
      }

      if (this.proposedCorrective) {
        let res = this.data.deviation.executionQTestDeviationData.findIndex(eqtdd => eqtdd.idType === TestTypeDeviations.PROPOSED_CORRECTIVE);

        if (res === -1) {
          if (this.proposedCorrective.comments && this.proposedCorrective.comments.trim() !== "") {
            this.proposedCorrective.idType = TestTypeDeviations.PROPOSED_CORRECTIVE;
           this.data.deviation.executionQTestDeviationData.push(this.proposedCorrective);
          }
        } else {
          this.data.deviation.executionQTestDeviationData[res].comments = this.proposedCorrective.comments;
        }
      }

      if (this.closedDeviation) {
        let res = this.data.deviation.executionQTestDeviationData.findIndex(eqtdd => eqtdd.idType === TestTypeDeviations.DEVIATION_CLOSED);

        if (res === -1) {
          if (this.closedDeviation.comments && this.closedDeviation.comments.trim() !== "") {
            this.closedDeviation.idType = TestTypeDeviations.DEVIATION_CLOSED;
            this.data.deviation.executionQTestDeviationData.push(this.closedDeviation);
          }
        } else {
          this.data.deviation.executionQTestDeviationData[res].comments = this.closedDeviation.comments;
        }
      }

      if (this.evaluation) {
        let res = this.data.deviation.executionQTestDeviationData.findIndex(eqtdd => eqtdd.idType === TestTypeDeviations.VALUATION);

        if (res === -1) {
          if (this.evaluation.qualificationContinue != undefined || this.evaluation.valuation != undefined || (this.evaluation.comments && this.evaluation.comments.trim() !== "")) {
            this.evaluation.idType = TestTypeDeviations.VALUATION;
            this.data.deviation.executionQTestDeviationData.push(this.evaluation);
          }
        } else {
          this.data.deviation.executionQTestDeviationData[res].qualificationContinue = this.evaluation.qualificationContinue;
          this.data.deviation.executionQTestDeviationData[res].valuation = this.evaluation.valuation;
          this.data.deviation.executionQTestDeviationData[res].comments = this.evaluation.comments;
        }
      }

      this.spinnerService.show();
      this.data.deviation.idExecutionTest = this.data.idExecutionTest;
      this.deviationService.updateDeviation(this.data.idExecution, this.data.idExecutionTest, this.data.deviation).pipe(takeUntil(this.destroy$)).subscribe((resdata: ExecutionQTestDeviations) => {
        this.snackBarService.sendSuccess(this.translate.instant('deviation.form.save.ok') as string);
        this.spinnerService.hide();
        this.dialogRef.close(resdata);
      }, error => {
        this.spinnerService.hide();
        console.log(error);
      });
    }
  }

  downloadDeviation() {
    this.spinnerService.show();
    this.executionService.downloadDeviationPdf(this.data.deviation.id, this.reportConfig).pipe(takeUntil(this.destroy$)).subscribe((res: Blob) => {
      const name = ExecutionUtils.getNameDeviationQForReportPdf(this.data.deviation, this.translate);
      saveAs(res, name);
      this.spinnerService.hide();
    }, () => {
      this.snackBarService.sendError(this.translate.instant('protocolEdit.dialog.generateReport.form.error.generic') as string);
      this.spinnerService.hide();
    });
  }


  onNoClick() {
    this.dialogRef.close(null);
  }

  getErroresDeviation(): string[] {
    let errors = [];

    if (StringUtils.isEmpty(this.commentsDeviation?.comments)) {
      errors.push('Debe ingresar la descripción de la desviación')
    }

    if (this.evaluation?.valuation === null || this.evaluation?.valuation === undefined) {
      errors.push('Debe seleccionar una valoración')
    }

    if (this.evaluation?.qualificationContinue === null || this.evaluation?.qualificationContinue === undefined) {
      errors.push('Debe indicar si prosigue o no la cualificación')
    }

    if (StringUtils.isEmpty(this.evaluation?.comments)) {
      errors.push('Debe ingresar la evaluación de la desviación')
    }

    if (this.deviationResolution?.resolved) {
      if (StringUtils.isEmpty(this.deviationResolution.comments)) {
        errors.push('La desviación esta marcada como resulta, por favor ingrese los comentarios de su resolución')
      }

      if (StringUtils.isEmpty(this.proposedCorrective.comments)) {
        errors.push('Debe ingresar las acciones correctoras')
      }
    }

    return errors;
  }

  changeSeeMore(): void {
    if (this.seeMore) {
      this.seeMore = false
    } else {
      this.seeMore = true;
    }
  }

  uploadAttachment(event): void {
    const files = Array.from(event.target.files as FileList);
    const promises: Observable<void>[] = [];

    if (!ArrayUtils.isEmpty(files)) {
      this.spinnerService.show();

      if (this.data.deviation.id) {
        files.forEach(file => {

          if (file.type !== 'application/pdf' && !file.name.toLowerCase().endsWith('.pdf')) {
            this.snackBarService.sendError(
              this.translate.instant('executionEdit.attachments.dialog.form.upload.error.invalidFile') as string
            );
            this.spinnerService.hide();
            return;
          }
          promises.push(this.attachmentService.uploadAttachmentToDeviation(this.data.deviation.id, file) as Observable<void>);
        });
  
        forkJoin(promises).pipe(takeUntil(this.destroy$)).subscribe((response: any) => {
          this.spinnerService.hide();
  
          this.data.deviation.idAttachment = response[0];
  
          this.snackBarService.sendSuccess(this.translate.instant('executionEdit.attachments.dialog.form.upload.ok') as string);
        }, (error) => {
          this.spinnerService.hide();
          console.error('Error al subir el archivo:', error);
          this.snackBarService.sendError(this.translate.instant('executionEdit.attachments.dialog.form.upload.error.generic') as string);
        });
      } else {
        const errores = this.getErroresDeviation();

        if (errores.length !== 0) {
          this.snackBarService.sendError(errores.join('\n'));
        } else {
          files.forEach(file => {

            if (file.type !== 'application/pdf' && !file.name.toLowerCase().endsWith('.pdf')) {
              this.snackBarService.sendError(
                this.translate.instant('executionEdit.attachments.dialog.form.upload.error.invalidFile') as string
              );
              this.spinnerService.hide();
              return;
            }
            this.data.deviation.file = file;
          });
        }
      }
    }
  }

  deleteAttachment(idAtt: number, idDeviation: number): void {
    this.spinnerService.show();
    this.attachmentService.deleteAttachmentToDeviation(idAtt, idDeviation).subscribe({
      next: (updateDeviation) => {

        this.snackBarService.sendSuccess(this.translate.instant('executionEdit.attachments.dialog.form.delete.ok') as string);
        this.data.deviation = updateDeviation;
        this.spinnerService.hide();
      },
      error: (err) => {
        if (err.status === 404) {
          this.snackBarService.sendError(this.translate.instant('executionEdit.attachments.dialog.form.not.found') as string);
        } else {
          this.snackBarService.sendError(this.translate.instant('executionEdit.attachments.dialog.form.delete.error') as string);
        }
        this.spinnerService.hide();
      }
    });
  }

  downloadAttachment(idAtt: number): void {
    this.spinnerService.show();

    this.attachmentService.downloadAttachmentToDeviation(idAtt)
      .pipe(takeUntil(this.destroy$))
      .subscribe((res: Blob) => {
        saveAs(res, `deviation-${idAtt}.pdf`);
        this.spinnerService.hide();
      }, error => {
        console.error(error);
        this.spinnerService.hide();
      });
  }

  showInExecution() {
    const allowedStatuses = [ExecutionStatus.EN_EJECUCION];
    return allowedStatuses.includes(this.data.idStatus);
  }

  onDeviationSelectChange(event: MatSelectChange) {
    if (event) {
      
    }
  }


}
